/* eslint-disable no-unused-vars */
import { stokpress, stokpressViewPort } from "../util/helper";
/* eslint-disable no-undef */

var Video = {};
Video.Selector = {
  hideOnPlay: ".js-hide-on-play",
  removeOnPlay: ".js-remove-on-play"
};
Video.Classes = {
  hide: "d-none",
  playButton: "js-playvideo"
};
window.onPlayerStateChange = function (event) {
  if (event.data === YT.PlayerState.PLAYING) {
    var target = event.target.a;
    if (target) {
      var elToRemove = target.parentNode.parentNode.querySelectorAll(Video.Selector.removeOnPlay);
      Video.removeElement(elToRemove);
      var elToHide = target.parentNode.parentNode.querySelectorAll(Video.Selector.hideOnPlay);
      Video.hideElement(elToHide, "hide");
      target.style.opacity = 1;
    }
  }
};

// Youtube callbacks
window.onYouTubeIframeAPIReady = function () {
  for (var i = 0; i < Video.iframes.length; i++) {
    new YT.Player(Video.iframes[i].id, {
      events: {
        onStateChange: onPlayerStateChange
      }
    });
  }
};
Video.isMobile = function () {
  return stokpress.isMobile() || stokpressViewPort.documentWidth().width < 720;
};
Video.initializeVimeo = function (iframes) {
  if (iframes.length === 0) {
    return;
  }
  for (var i = 0; i < iframes.length; i++) {
    var source = iframes[i].getAttribute("data-source");
    if (source !== "vimeo") {
      continue;
    }
    var videoParent = Video.getElParent(iframes[i]);
    var playVideo = videoParent.querySelector("." + Video.Classes.playButton);
    if (!playVideo) {
      continue;
    }
    playVideo.addEventListener("click", function (event) {
      event.preventDefault();
      var targetParent = Video.getElParent(this);
      var elToHide = Video.removeElementsOnPlay(targetParent);
      var iframe = targetParent.querySelector(".js-video-iframe");
      iframe.style.opacity = 1;
      var player = new Vimeo.Player(iframe);
      Video.vimeoOnStateChanged(player, elToHide);
    });
  }
};
Video.vimeoOnStateChanged = function (player, elToHide) {
  if (!player) {
    return;
  }
  player.getPaused().then(function (paused) {
    if (paused) {
      player.play();
      Video.hideElement(elToHide, "hide");
    } else {
      player.pause();
      Video.hideElement(elToHide, "show");
    }
  });
};
Video.initializeYoutube = function (iframe) {
  var videoParent = Video.getElParent(iframe);
  var playVideo = videoParent.querySelector("." + Video.Classes.playButton);
  // var playVideo = stokpress.findAncestor( iframe, Video.Classes.playButton );

  if (!playVideo) {
    return;
  }
  playVideo.addEventListener("click", function (event) {
    event.preventDefault();
    var targetParent = Video.getElParent(this);
    var elToHide = Video.removeElementsOnPlay(targetParent);

    // var elToRemove = this.querySelectorAll( Video.Selector.removeOnPlay );
    // Video.removeElement( elToRemove );

    // var elToHide = this.querySelectorAll( Video.Selector.hideOnPlay );
    // Video.hideElement( elToHide, 'hide' );

    iframe.style.opacity = 1;
    if (iframe.src.includes("&autoplay=1") === false) {
      iframe.src += "&autoplay=1";
    }
  });
};
Video.iframeProcess = function () {
  var includeYoutubeScript = false,
    includeVimeoScript = false;
  for (var i = 0; i < Video.iframes.length; i++) {
    var source = Video.iframes[i].getAttribute("data-source");
    if (!Video.iframes[i].getAttribute("data-autoplay") || Video.isMobile()) {
      var playOnMobile = Video.iframes[i].getAttribute("data-showonmobile");
      if (source === "vimeo") {
        includeVimeoScript = true;
      } else if (source === "youtube") {
        if (Video.isMobile()) {
          if (playOnMobile === "true") {
            Video.iframes[i].style.zIndex = 5;
            includeYoutubeScript = true;
          }
        } else {
          Video.initializeYoutube(Video.iframes[i]);
        }
      }
    } else {
      var videoParent = Video.getElParent(Video.iframes[i]);
      Video.removeElementsOnPlay(videoParent);
      Video.iframes[i].style.opacity = 1;
    }
  }
  if (includeVimeoScript) {
    stokpress.getScript("https://player.vimeo.com/api/player.js", function () {
      Video.initializeVimeo(Video.iframes);
    });
  }
  if (includeYoutubeScript) {
    stokpress.getScript("https://www.youtube.com/iframe_api");
  }
};
Video.removeElement = function (elToHide) {
  if (!elToHide) {
    return;
  }
  Array.prototype.forEach.call(elToHide, function (element) {
    element.parentNode.removeChild(element);
  });
};
Video.hideElement = function (items, action) {
  if (!items) {
    return;
  }
  Array.prototype.forEach.call(items, function (item) {
    if (action === "hide") {
      item.classList.add(Video.Classes.hide);
    } else {
      item.classList.remove(Video.Classes.hide);
    }
  });
};
Video.getElParent = function (el) {
  if (!el) {
    return;
  }
  var wrapperClass = el.dataset.targetCont;
  var parent = el.parentNode.parentNode;
  if (typeof wrapperClass !== "undefined") {
    parent = stokpress.findAncestor(el, wrapperClass);
  }
  return parent;
};
Video.removeElementsOnPlay = function (wrapperEl) {
  if (!wrapperEl) {
    return;
  }
  var elToRemove = wrapperEl.querySelectorAll(Video.Selector.removeOnPlay);
  Video.removeElement(elToRemove);
  var elToHide = wrapperEl.querySelectorAll(Video.Selector.hideOnPlay);
  Video.hideElement(elToHide, "hide");
  return elToHide;
};
Video.init = function () {
  Video.iframes = document.querySelectorAll("iframe.js-video-iframe");
  // Video.tags = document.querySelectorAll("video.js-video-tag");

  if (Video.iframes.length) {
    Video.iframeProcess();
  }

  // if (Video.tags.length) {
  //     for (var i = 0; i < Video.tags.length; i++) {
  //         var videoParent = Video.getElParent(Video.tags[i]);

  //         if (videoParent) {
  //             if (Video.tags[i].getAttribute("autoplay")) {
  //                 Video.removeElementsOnPlay(videoParent);
  //                 Video.tags[i].style.zIndex = 1;
  //             }

  //             var playVideo = videoParent.querySelector(
  //                 "." + Video.Classes.playButton
  //             );

  //             if (playVideo) {
  //                 playVideo.addEventListener("click", function (event) {
  //                     event.preventDefault();

  //                     var targetParent = Video.getElParent(this);
  //                     var elToHide = Video.removeElementsOnPlay(targetParent);
  //                     var targetVideo = targetParent.querySelector("video");

  //                     if (targetVideo.paused == false) {
  //                         targetVideo.pause();
  //                         Video.hideElement(elToHide, "show");
  //                     } else {
  //                         targetVideo.play();
  //                         Video.hideElement(elToHide, "hide");
  //                     }

  //                     targetVideo.style.zIndex = 1;
  //                 });
  //             }
  //         }
  //     }
  // }
};
document.addEventListener("DOMContentLoaded", function () {
  Video.init();
});
window.Video = Video;


// WEBPACK FOOTER //
// ./scripts/components/video.js